module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.currentSection.section,
    style: (_vm.backgroundStyle),
    attrs: {
      "id": "cityContainer"
    }
  }, [_c('div', {
    attrs: {
      "id": "side-panel"
    }
  }, [_c('div', {
    attrs: {
      "id": "side-panel-1"
    }
  }, [_c('city-dropdown', {
    attrs: {
      "sectionKey": _vm.sectionKey,
      "city": _vm.city
    }
  }), _vm._v(" "), _c('city-summary', {
    attrs: {
      "sectionKey": _vm.sectionKey,
      "city": _vm.city
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "side-panel-2"
    }
  }, [_c('section-dropdown', {
    attrs: {
      "sections": _vm.sections,
      "sectionKey": _vm.sectionKey
    },
    on: {
      "setKey": _vm.setKey
    }
  }), _vm._v(" "), (_vm.sectionKey != 0) ? _c('section-summary', {
    attrs: {
      "city": _vm.city,
      "section": _vm.currentSection
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.currentSection.section === 'city-header') ? _c('div', {
    staticClass: "grid center",
    attrs: {
      "id": "city-header-data"
    }
  }, [_c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Population\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.population))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Density\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.density))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("\n      persons/hectare\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 mob-1-1"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        " + _vm._s(_vm.city.City.t3.substr(0, 4)) + " Urban Extent\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.commas(_vm.city.City.extent))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "unit"
  }, [_vm._v("\n        hectares\n      ")])])]) : [_c('map-graphs', {
    attrs: {
      "city": _vm.city,
      "currentSection": _vm.currentSection
    }
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d9f94dc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/City.vue
// module id = 303
// module chunks = 1